<template>
  <div class="signView" data-app>
    <v-sheet class="mainTitle">
      <v-card-title style="font-size: 3vh; margin-bottom: 2vh">Nomad Map</v-card-title>
      <v-card-subtitle style="font-size: large">
        <div class="word-container">
          <span class="static-text">No More "Who's in </span>
          <transition name="rotate-fade" mode="out-in">
            <span :key="cityKey">{{ currentCity }}</span>
          </transition>
          <span class="static-text"> in </span>
          <transition name="rotate-fade" mode="out-in">
            <span :key="monthKey">{{ currentMonth }}</span>
          </transition>
          <span class="static-text">?"</span>
        </div>
      </v-card-subtitle>
    </v-sheet>
    <v-expand-transition>
      <v-card class="registrationCard" elevation="20" v-show="!isSignIn">
        <v-card-title>Sign Up</v-card-title>
        <v-form @submit.prevent="handleSignUp">
          <v-text-field v-model="fullName" placeholder="Full Name"></v-text-field>
          <v-text-field v-model="signupEmail" persistent-hint :hint="this.emailError" type="email" placeholder="Email" @blur="signUnValidateEmail"></v-text-field>
          <v-text-field v-model="signupPassword" type="password" placeholder="Password"></v-text-field>
          <v-autocomplete
              v-model="originCountry"
              :items="countries"
              label="Origin Country"
              auto-select-first
              hint="Optional"
              persistent-hint
          ></v-autocomplete>
          <v-btn :disabled="disableSignup" type="submit" class="signUpButton">Sign Up</v-btn>
        </v-form>
<!--        <div class="signUpFooter">-->
<!--          <a>Already Have An Account?</a>-->
<!--          <a @click="togglePanel(isSignIn)"> Sign In</a>-->
<!--        </div>-->
        <v-card-actions style="position: relative; bottom: 0; text-align: center">
          <v-card-subtitle style=" font-size: medium;">Already Have An Account? <a style="font-weight: bold;" @click="togglePanel(isSignIn)" > Sign In</a></v-card-subtitle>
        </v-card-actions>
      </v-card>
    </v-expand-transition>

    <v-expand-transition>
        <v-card class="registrationCard" elevation="20" v-show="isSignIn">
          <v-card-title>Sign In</v-card-title>
          <div style="text-align: center">
            <v-btn class="googleButton" @click="handleGoogleSignIn"><v-img :src="require('@/assets/google-1088004_640.png')" class="googleLogo"></v-img>With Google</v-btn>
            <div class="divider"><p>OR</p></div>
            <v-form @submit.prevent="handleLogin">
              <v-text-field v-model="signinEmail" type="email" placeholder="Email"></v-text-field>
              <v-text-field v-model="signinPassword" type="password" placeholder="Password"></v-text-field>
              <div style="text-align: right; margin-bottom: 20px;">
                <a @click="handleForgotPassword" style="cursor: pointer; font-size: small;">Forgot Password?</a>
              </div>
              <v-btn type="submit" class="signInButton">Sign In</v-btn>
            </v-form>
          </div>
          <v-card-actions style="position: relative; bottom: 0; text-align: center">
            <v-card-subtitle style=" font-size: medium;">New Here? <a style="font-weight: bold;" @click="togglePanel(isSignIn)" > Sign Up</a></v-card-subtitle>
          </v-card-actions>
        </v-card>
    </v-expand-transition>
    <v-alert transition="scroll-y-transition" dismissible v-model="badSignInAlert" type="error" color="red" dense origin="top" class="registrationAlert">
      {{ this.badSignInMessage }}
    </v-alert>
    <v-alert transition="scroll-y-transition" dismissible v-model="badSignUpAlert" type="error" color="red" dense origin="top" class="registrationAlert">
      {{ this.badSignUpMessage }}
    </v-alert>
    <v-alert transition="scroll-y-transition" dismissible v-model="resetPasswordErrorAlert" type="error" color="red" dense origin="top" class="registrationAlert">
      {{ this.emailError }}
    </v-alert>
    <v-alert transition="scroll-y-transition" dismissible v-model="goodSignUpAlert" type="success" dense origin="top" class="registrationAlert">
      Check your email for the login link!
    </v-alert>
    <v-alert transition="scroll-y-transition" dismissible v-model="resetPasswordSuccessAlert" type="success" dense origin="top" class="registrationAlert">
      Reset password email sent to {{this.signinEmail}}!
    </v-alert>
    <div>
      <!-- Google One-Tap Sign-In container -->
      <div id="g_id_onload"
           :data-client_id="clientId"
           data-callback="handleGoogleOneTap">
      </div>
    </div>
  </div>
</template>

<script>
import supabase from "@/lib/supabaseClient"
import Vue from 'vue'
import VueRouter from 'vue-router'
import {countries} from "@/assets/countries";
Vue.use(VueRouter)

export default {
  data() {
    return {
      googleClientId: null,
      cities: [" Bansko ", " Bali ", " Las Palmas ", " Sri Lanka ", " Albania ", " Thailand ", " Mexico "],
      months: [" January", " April"," September", " May", " July", " August", " March",  " June", " October", " November", " February", " December"],
      currentCityIndex: 0,
      currentMonthIndex: 5,
      cityKey: 0,
      monthKey: 0,
      isSignIn: true,
      signupPassword: '',
      signupEmail: '',
      signinEmail: '',
      signinPassword: '',
      loading: false,
      originCountry: '',
      fullName: '',
      badSignInAlert: false,
      badSignUpAlert: false,
      goodSignUpAlert: false,
      badSignInMessage: null,
      badSignUpMessage: null,
      countries,
      emailError: '',
      disableSignup: true,
      resetPasswordErrorAlert: false,
      resetPasswordSuccessAlert: false
    };
  },
  computed: {
    currentCity() {
      return this.cities[this.currentCityIndex];
    },
    currentMonth() {
      return this.months[this.currentMonthIndex];
    },
    clientId() {
      return process.env.VUE_APP_GOOGLE_CLIENT_ID;
    }
  },

  mounted() {
    this.startRotatingVariables();
    this.googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
  methods: {
    async sendPasswordResetEmail() {
      try {
        const { data, error } = await supabase.auth.resetPasswordForEmail(this.signinEmail)
        if (error) throw error
        console.log(data)
        this.resetPasswordSuccessAlert = true
      } catch (error) {
        console.error('Error sending password reset email:', error.message);
      }
    },
    async handleForgotPassword() {
      if (!this.signinEmail) {
        // Email already exists in the user list
        this.emailError = 'Missing email';
        this.resetPasswordErrorAlert = true
        return
      } else if (this.signinEmail.indexOf('@') === -1) {
        this.emailError = 'Invalid email';
        this.resetPasswordErrorAlert = true
        return
      }
      let emailExists = await this.validateEmail(this.signinEmail)
      if (!emailExists) {
        // Email already exists in the user list
        this.emailError = 'No account found under ' + this.signinEmail;
        this.resetPasswordErrorAlert = true
      } else {
        // Email is not in the user list
        this.emailError = ''
        this.resetPasswordErrorAlert = false
        await this.sendPasswordResetEmail()
      }
    },
    async signUnValidateEmail() {
      let emailExists = await this.validateEmail(this.signupEmail)
      if (emailExists) {
        // Email already exists in the user list
        this.emailError = 'Email already taken';
        this.disableSignup = true
      } else {
        // Email is not in the user list
        this.emailError = ''
        this.disableSignup = false
      }
    },
    async validateEmail(emailToCheck) {
      try {
        let { data, error } = await supabase
            .from('users_data')  // Adjust if your table name is different
            .select('email')
            .eq('email', emailToCheck)

        if (error) throw error

        return data.length > 0
        // if (data.length > 0) {
        //   // Email already exists in the user list
        //   this.emailError = 'Email already taken';
        //   this.disableSignup = true
        // } else {
        //   // Email is not in the user list
        //   this.emailError = ''
        //   this.disableSignup = false
        // }
      } catch (error) {
        console.error('Error validating email:', error.message);
      }
    },
    startRotatingVariables() {
      setInterval(() => {
        this.cityKey++;
        this.monthKey++;
        this.currentCityIndex = (this.currentCityIndex + 1) % this.cities.length;
        this.currentMonthIndex = (this.currentMonthIndex + 1) % this.months.length;
      }, 3000); // Change variables every 1.5 seconds (adjust as needed)
    },
    togglePanel(isSignIn) {
      this.isSignIn = !isSignIn;
    },
    getInitials(fullName) {
      const words = fullName.split(' ');

      if (words.length >= 2) {
        const firstInitial = words[0][0].toUpperCase();
        const lastInitial = words[words.length - 1][0].toUpperCase();

        const initials = firstInitial + lastInitial;

        return initials;
      } else {
        return "Invalid Input";
      }
    },
    async handleGoogleSignIn() {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          },
        },
      })
      if (error) throw error
      console.log(data)
    },
    async handleFacebookSignIn() {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'facebook',
      })
      if (error) throw error
      console.log(data)
    },
    async handleSignUp() {
      try {
        this.loading = true

        this.fullName = this.fullName.trim()
        this.signupEmail = this.signupEmail.trim()
        this.originCountry = this.originCountry.trim()

        const  { data, error } = await supabase.auth.signUp({
          email: this.signupEmail,
          password: this.signupPassword,
          options: {
            data: {
              origin_country: this.originCountry,
              full_name: this.fullName,
              initials: this.getInitials(this.fullName)
            }
          }
        })
        if (error) throw error
/*
        alert('Check your email for the login link!')
*/
        this.goodSignUpAlert = true
        this.fullName = ''
        this.signupEmail = ''
        this.originCountry = ''
        this.togglePanel(this.isSignIn)
        console.log(data)
      } catch (error) {
        if (error instanceof Error) {
          console.log(error)
/*
          alert(error.message)
*/
          this.badSignUpAlert = true
          this.badSignUpMessage = error.message
        }
      } finally {
        this.loading = false
      }
    },
    async handleLogin() {
      try {
        this.loading = true
        const  { error } = await supabase.auth.signInWithPassword({
          email: this.signinEmail,
          password: this.signinPassword,
        })
        if (error) throw error
        await this.$router.push('/');
      } catch (error) {
        if (error instanceof Error) {
          console.log(error)
/*
          alert(error)
*/
          this.badSignInAlert = true
          this.badSignInMessage = error.message
        }
      } finally {
        this.loading = false
      }
    },
  }
};
</script>

<style scoped>

.rotate-fade-enter-active,
.rotate-fade-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.rotate-fade-enter, .rotate-fade-leave-to /* .rotate-fade-leave-active in <2.1.8 */ {
  transform: rotateX(180deg);
  opacity: 0;
}


.rotatingText-adjective {
  animation: rotate-text-up 1.5s forwards;
  display: inline-block;
}

@keyframes rotate-text-up {
  0% {
    transform: translate3d(0, 10px, 0);
    opacity: 0;
  }

  25%, 75% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -10px, 0);
    opacity: 0;
  }
}
  .mainTitle {
    //position: absolute!important;
    top: 3vh;
    max-height: 70px;
    text-align: center;
    background: transparent;
  }
  .signView {
    font-family: 'Tisa Sans Pro', sans-serif !important;
  }
  .registrationAlert {
    top: 5vh;
    width: 75vw;
    text-align: center;
    position: fixed;
  }

  .app {
    display: flex;
    place-content: center;
    align-items: center;
    height: 100vh;
    font-family: 'Tisa Sans Pro', sans-serif !important;
  }
  .v-form {
    padding: 15px;
  }
  .v-sheet.v-card {
    border-radius: 15px;
  }

  .v-form {
    text-align: center;
  }

  .v-btn__content {
    color: aliceblue;
  }

</style>


<style>
.registrationCard {
  padding: 10px;
  opacity: 0.85;
  width: 80vw;
}
.signView {
  background: url("~@/assets/alberta-2297204_1920.webp") no-repeat fixed center;
  background-size: cover;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.signUpButton {
  margin-top: 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  padding: 0.9rem 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}

.signInButton {
  margin-top: 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  padding: 0.9rem 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}


.signUpFooter {
  padding: 15px;
}

.googleLogo {
  margin-right: 16px;
  height: 24px;
  width: 24px;
}

.googleButton {
  text-transform: capitalize;
  margin: 3px;
}


.divider {
  border-top: 2px solid black;
  position: relative;
  margin-top: 26px;
  z-index: 0;
}

.divider p {
  position: absolute;
  top: -18px;
  left: 45%;
  z-index: 999;
  border-radius: 50%;
  padding: 5px;
  background: white;
}


</style>

